import { Fragment, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import useAxios from "../../../hook/useAxios";
import ActionItem from "../../Global/ActionItem";
import { toast } from "react-toastify";
import WarningRedAlert from "../../ErrorAndAlert/WarningRedAlert";
import { CommunityRecord } from "../../../type/communityRecord";
import { Link } from "react-router-dom";

const CommunityTableItem: React.FC<{
  community: CommunityRecord;
  fetchData: () => void;
  lastIndex: number;
}> = ({ community, fetchData: propFetchData, lastIndex }) => {
  const { i18n, t } = useTranslation();
  const [showDelete, isShowDelete] = useState<boolean>(false);

  const { response: deleteR, fetchData } = useAxios(
    process.env.REACT_APP_API_URL +
      `/api/admin/communities/${community.id}/delete/`,
    "DELETE",
    false,
    `${t("Message.Successful delete")}`,
    true,
    true
  );
  useEffect(() => {
    if (deleteR) {
      isShowDelete(false);
      propFetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteR]);
  const deleteAction = () => {
    if (community.is_deletable) {
      isShowDelete(true);
    } else {
      toast.error(
        t(
          "Message.Delete community"
        )
      );
    }
  };

  const hide = () => {
    isShowDelete(false);
  };

  const deleteItem = () => {
    fetchData({});
  };
  const active =
    i18n.language === "en"
      ? community.is_active_transes.en
      : community.is_active_transes.fr;
  return (
    <Fragment>
      <TableCell align="left">
        <Link
          className="hover:text-[#0884B8]"
          to={`/setting/communities/view-community/${community.slug}`}
        >
          {community.name}
        </Link>
      </TableCell>
      <TableCell>{community.department}</TableCell>
      <TableCell>{community.municipality}</TableCell>
      <TableCell>{community.initials}</TableCell>
      <TableCell>
        <p
          className={`${
            community.is_active_transes.en === "Active"
              ? "bg-ph-toggle-bg-green text-ph-toggle-text-green"
              : "bg-ph-toggle-bg-red text-ph-red-warning"
          } text-center w-16 py-1 rounded-xl`}
        >
          {active}
        </p>
      </TableCell>

      <TableCell align="right">
        <ActionItem
          delete={true}
          editLink={`/setting/communities/edit-community/${community.slug}`}
          deleteAction={deleteAction}
          view=""
          viewLink={`/setting/communities/view-community/${community.slug}`}
          viewCommunity={t("Community.View") + ""}
          historyLink=""
          viewHistory=""
          width="w-[115px]"
        />
      </TableCell>
      {showDelete && (
        <WarningRedAlert
          type={t("Community.Community")}
          hide={hide}
          action={deleteItem}
          isDelete={true}
          isSignOut={false}
        />
      )}
    </Fragment>
  );
};

export default CommunityTableItem;
